import { FC } from "react";
import { Button, Grid } from "@material-ui/core";
import ReactHtmlParser from 'react-html-parser';

import ImageSlider from "./ImageSlider";
import PoolDetailStyle from "./DetailsStyle";
import ProjectStage from "./ProjectStage";
import TeamSection from "./TeamSection";
import LogoCardList from "./LogoCardList";
import DynamicSection from "./DynamicSection";
import Loader from "../../helpers/Loader";
import { Skeleton } from "@material-ui/lab";

const SectionLoader:FC<any> = () => {
    return (
        <Grid
            container
            direction="column"
        >
            <Grid item>
                <Skeleton variant="text" animation="wave" height={40} width={170} />
            </Grid>
            <Grid item>
                <Skeleton variant="rect" animation="wave" height={300} style={{
                    marginTop: "10px",
                    borderRadius: "17px",
                }} />
            </Grid>
        </Grid>
    )
}

const AboutSection: FC<any> = ({ poolData, poolContent }: any) => {

    const classes = PoolDetailStyle();

    if (!poolData) return (
        <SectionLoader />
    )

    return (
        <Grid
            container
            direction="column"
        >
            {/* <Grid
                item
            >
                <ImageSlider images={[]} />
            </Grid> */}
            {/* <Grid
                item
            >
                <Grid 
                    container
                    style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                    }}
                    spacing={2}
                    xs={12}
                    lg={12}
                    sm={12}
                    md={12}
                >
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                    >
                        <Button variant="outlined" className={classes.externalLinks} disabled fullWidth>
                            Whitepaper
                        </Button>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                    >
                        <Button variant="outlined" className={classes.externalLinks} disabled fullWidth>
                            Tokenomics
                        </Button>
                    </Grid>
                </Grid>
            </Grid> */}
            {/* <Grid
                item
                style={{
                    marginTop: "10px",
                }}
            >
                <ProjectStage />
            </Grid>
            <Grid
                item
                style={{
                    marginTop: "10px",
                }}
            >
                <TeamSection />
            </Grid>
            <Grid
                item
                style={{
                    marginTop: "10px",
                }}
            >
                <LogoCardList heading="Partners" />
            </Grid>
            <Grid
                item
                style={{
                    marginTop: "10px",
                }}
            >
                <LogoCardList heading="Backers" />
            </Grid> */}
            <Grid
                item
            >
                <DynamicSection content={poolContent} poolData={poolData} />
            </Grid>
        </Grid>
    )
}

export default AboutSection;